import { observable } from "@legendapp/state";
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage";
import { synced } from "@legendapp/state/sync";
import type { ThemePreference, ThemeType } from "@repo/shared/types/theme";

export const theme$ = observable(
  synced<{
    preference: ThemePreference;
    theme: ThemeType;
  }>({
    initial: {
      preference: "dark",
      theme: "dark",
    },
    persist: {
      name: "theme",
      plugin: ObservablePersistLocalStorage,
    },
  }),
);

theme$.preference.onChange(
  ({ value }) => {
    if (typeof window === "undefined") return;
    const root = window.document.documentElement;

    root.classList.remove("light", "dark");

    if (value === "system") {
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)")
        .matches
        ? "dark"
        : "light";

      root.classList.add(systemTheme);
      theme$.theme.set(systemTheme);
      return;
    }

    root.classList.add(value);
    theme$.theme.set(value);
  },
  {
    initial: true,
  },
);
